import {
  DETAIL_SET,
  DETAIL_SET_SUCCESS,
  DETAIL_SET_ERROR,
  DETAIL_GET_COUNTRY,
  DETAIL_GET_COUNTRY_SUCCESSFULL,
  DETAIL_GET_COUNTRY_FAILED,
  DETAIL_GET_STATE,
  DETAIL_GET_STATE_SUCCESSFULL,
  DETAIL_GET_STATE_FAILED,
  DETAIL_GET_IP_LOCATION,
  DETAIL_GET_IP_LOCATION_FAILED,
  DETAIL_GET_IP_LOCATION_SUCCESSFULL,
  GET_COUNTRY_BY_IP,
  GET_COUNTRY_BY_IP_SUCCESSFULL,
  GET_COUNTRY_AND_STATE,
  GET_COUNTRY_AND_STATE_SUCCESS,
  GET_COUNTRY_AND_STATE_FAILED,
  CAREER_PREVIEW_PROFILE_UPDATE,
  CAREER_PREVIEW_PROFILE_UPDATE_SUCCESS,
  CAREER_PREVIEW_PROFILE_UPDATE_FAILURE,
  SEND_TO_DEVELOPER,
  SEND_TO_DEVELOPER_SUCCESS,
  SEND_TO_DEVELOPER_FAILURE,

} from "./actionTypes"

export const detailSet = (user, history) => {
  return {
    type: DETAIL_SET,
    payload: { user, history },
  }
}

export const detailSetSuccess = message => {
  return {
    type: DETAIL_SET_SUCCESS,
    payload: message,
  }
}

export const detailSetError = message => {
  return {
    type: DETAIL_SET_ERROR,
    payload: message,
  }
}
//GET COUNTRY
export const detailGetCountry = (country) => {
  return {
    type: DETAIL_GET_COUNTRY,
    payload: {country},
  }
}
export const detailSetCountrySuccess = (country) => {
  return {
    type: DETAIL_GET_COUNTRY_SUCCESSFULL,
    payload: country,
  }
}
export const detailSetCountryError = (country) => {
  return {
    type: DETAIL_GET_COUNTRY_FAILED,
    payload: country,
  }
}
//GET STATE FUNCTIONS
export const detailGetState = (states) => {
  return {
    type: DETAIL_GET_STATE,
    payload: {states},
  }
}
export const detailSetStateSuccess = (states) => {
  return {
    type: DETAIL_GET_STATE_SUCCESSFULL,
  payload: states,
  }
}
export const detailSetStateError = (states) => {
  return {
    type: DETAIL_GET_STATE_FAILED,
    payload: states,
  }
}
//GET COUNTRY AND STATE ON IP BASED FUNCTIONS
export const detailGetIpBasedLocation = (iplocation) => {
  return {
    type: DETAIL_GET_IP_LOCATION,
    payload: {iplocation},
  }
}
export const detailGetIpBasedLocationSuccess = (iplocation) => {
  return {
    type: DETAIL_GET_IP_LOCATION_SUCCESSFULL,
  payload: iplocation,
  }
}
export const detailGetIpBasedLocationError = (iplocation) => {
  return {
    type: DETAIL_GET_IP_LOCATION_FAILED,
    payload: iplocation,
  }
}

export const getCountryByIp=()=>{
  return{
    type:GET_COUNTRY_BY_IP,
  }
}

export const getCountryByIpSuccessfull=(country)=>{
  return{
    type:GET_COUNTRY_BY_IP_SUCCESSFULL,
    payload:country
  }
}


export const getCountryAndState=(city)=>{
  return{
    type:GET_COUNTRY_AND_STATE,
    payload:city
  }
}

export const getCountryAndStateSuccess=(data)=>{
  return{
    type:GET_COUNTRY_AND_STATE_SUCCESS,
    payload:data
  }

}

export const getCountryAndStateFailure=(error)=>{
  return{
    type:GET_COUNTRY_AND_STATE_FAILED,
    payload:error
  }
}

export const updateCareerProfilePreview=(preview)=>{
  return{
    type:CAREER_PREVIEW_PROFILE_UPDATE,
    payload:{preview}
  }
}

export const updateCareerProfilePreviewSuccess=(preview)=>{
  return{
    type:CAREER_PREVIEW_PROFILE_UPDATE_SUCCESS,
    payload:preview
  }

}

export const updateCareerProfilePreviewFailure=(error)=>{
  return{
    type:CAREER_PREVIEW_PROFILE_UPDATE_FAILURE,
    payload:error
  }

}

export const sendtoDeveloper = (data) => {
  return {
    type:SEND_TO_DEVELOPER,
    payload:data
  }
}

export const sendtoDeveloperSuccess = (data) => {
  return {
    type:SEND_TO_DEVELOPER_SUCCESS,
    payload:data
  }
}

export const sendtoDeveloperFailure = (error) => {
  return {
    type:SEND_TO_DEVELOPER_FAILURE,
    payload:error
  }
}